import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import {useConfigModule} from "base/ui/module/provider";
import {LocationProvider} from "snimf/location/provider";
import {useErrors} from "base/error/provider";
import {HolderService} from "holder/service";

import {HolderSubPageMenu} from "holder/menu";
import {PageLayout} from "base/ui/main";

const ViewHolderPage = () => {
    const {id} = useParams();
    const {handleErrors} = useErrors();

    const [holder, setHolder] = useState(null);
    const location = useLocation();

    const {setModuleBasePath, isLoading, setIsLoading} = useConfigModule();

    useEffect(() => {
        setIsLoading(true);
        setHolder(null);
        setModuleBasePath(`/permits/holders/list/${id}`);
        HolderService.get(id)
            .then(data => {
                setHolder(data);
            })
            .catch(error => {
                handleErrors(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id, location.state?.lastRefreshDate]);

    return (
        <LocationProvider>
            <PageLayout
                menu={<HolderSubPageMenu holder={holder} />}
                context={[holder]}
                isLoading={isLoading}
                subPage
            />
        </LocationProvider>
    );
};

export default ViewHolderPage;
